import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        textAlign="center"
        p={3}
      >
        <MDBox mb={2}>
          <MDTypography variant="h1" color="error" fontWeight="bold">
            404
          </MDTypography>
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="h3" fontWeight="medium">
            ¡Oops! Página no encontrada
          </MDTypography>
        </MDBox>

        <MDBox mb={4} maxWidth="600px">
          <MDTypography variant="body1" color="text">
            La página que estás buscando no existe o ha sido movida. Por favor verifica la URL o
            regresa a la página principal.
          </MDTypography>
        </MDBox>

        <MDBox>
          <Button
            variant="gradient"
            color="info"
            size="large"
            onClick={() => navigate("/")}
            sx={{
              borderRadius: "12px",
              padding: "12px 24px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <MDTypography variant="button" color="white" fontWeight="medium">
              Volver al inicio
            </MDTypography>
          </Button>
        </MDBox>

        <MDBox mt={6} width="100%" maxWidth="400px">
          <img
            src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
            alt="404 error"
            style={{ width: "100%", borderRadius: "12px" }}
          />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default NotFound;
